import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from, of } from "rxjs";
import { eContracts } from "../contract.config";
import { eCurrencies } from "app/common/ui/info-icon/info-icon.interface";
import { getCurrencyContract } from "app/services/companyItems/company-items.interface";

@Injectable({
    providedIn: 'root'
})
/* ******************************
**********DEPRECATED ************
****************************** */
export class NFTService {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.KMONFT);
        // this.contractsService.getContractIstances(eContracts.KMONFT).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract(eContracts.KMONFT);
    }

    //Maybe is a boolean
    isApprovalForAll(ownerAddress: string, operatorAddress: string): Observable<any> {
        return from(this.contract.methods.isApprovedForAll(ownerAddress, operatorAddress).call());
    }

    ownedKryptomons(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.ownedKryptomons().call({ from: ownerAddress }));
    }

    //check if its a promise
    timeToHatch(): Observable<any> {
        return from(this.contract.methods.timeToHatch().call());
    }

    setApprovalForAll(ownerAddress: string, operatorAddress: string, approved: boolean): Observable<any> {
        return from(this.contract.methods.setApprovalForAll(operatorAddress, approved).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

}

@Injectable({
    providedIn: 'root'
})
export class NFTv2Service {

    public contract: any
    public contractNFTItems: any
    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.KMONFTV2);
        // this.contractsService.getContractIstances(eContracts.KMONFTV2).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract(eContracts.KMONFTV2);
        this.contractNFTItems = this.contractsService.getContract(eContracts.NFTItems);
    }

    //Maybe is a boolean
    isApprovalForAll(ownerAddress: string, operatorAddress: string): Observable<any> {
        return from(this.contract.methods.isApprovedForAll(ownerAddress, operatorAddress).call());
    }

    setApprovalForAll(ownerAddress: string, operatorAddress: string, approved: boolean): Observable<any> {
        return from(this.contract.methods.setApprovalForAll(operatorAddress, approved).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    safeBatchTransferFrom(fromAddress: string, receiverAddress: string, ids: string[], values: number[], data: any): Observable<any> {
        return from(this.contract.methods.safeBatchTransferFrom(fromAddress, receiverAddress, ids, values, data)
            .send({ ...this.contractsService.additionalParameters(), from: fromAddress }));
    }

    ownedKryptomons(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.ownedKryptomons().call({ from: ownerAddress }));
    }

    migrateBatch(ownerAddress: string, tokenIds: string[], genes: string[], deadlines: string[],
        vs: number[], rs: any[], ss: any[]): Observable<any> {
        return from(this.contract.methods.migrateBatch(tokenIds, genes, deadlines, vs, rs, ss).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }))
    }

    spinTheWheel(ownerAddress: string): Observable<any> {
        return from(this.contract.methods.spinTheWheel().send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    buyItem(ownerAddress: string, boxId: string, amount: number, currency: eCurrencies, price?: number): Observable<any> {
        if (currency === eCurrencies.CANDIES) {
            return from(this.contract.methods.purchaseItemsWithCandies(ownerAddress, [boxId], [amount]).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
        } else {
            let _currency = eContracts[currency];
            let currencyAddress: string = this.contractsService.getContractAddress(_currency);
            return from(this.contractNFTItems.methods.purchaseItems(ownerAddress, [boxId], [amount], currencyAddress).send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
        }
    }

    getUpgradeItemsDefinitions(): Observable<any> {
        return from(this.contractNFTItems.methods.getUpgradeItemsDefinitions().call())
    }

    getAllPurchasableItems(): Observable<any> {
        return from(this.contractNFTItems.methods.getAllPurchasableItems().call())
    }

    upgradeItem(ownerAddress: string, itemUpgradeId: string, mainItemId: string, materialIds: string[], materialQuantities: string[]): Observable<any> {
        return from(this.contractNFTItems.methods.upgradeItem(
            itemUpgradeId,
            mainItemId,
            materialIds,
            materialQuantities
        )
            .send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    transferFrom(ownerAddress: string, receiverAddress: string, tokenId: string): Observable<any> {
        return from(this.contract.methods.transferFrom(ownerAddress, receiverAddress, tokenId).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }))
    }

    evolveKryptomon(ownerAddress: string, tokenId: string): Observable<any> {
        return from(this.contract.methods.evolveKryptomon(tokenId).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }));
    }

    addToBreedingCentre(ownerAddress: string, tokenId: string, kmonPrice: number): Observable<any> {
        return from(this.contract.methods.addToBreedingCentre(tokenId, this.web3Service.toWei(kmonPrice, 'ether')).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }));
    }

    removeFromBreedingCentre(ownerAddress: string, tokenId: string): Observable<any> {
        return from(this.contract.methods.removeFromBreedingCentre(tokenId).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }));
    }

    simulateBreeding(matronTokenId: string, sireTokenId: string): Observable<number[]> {
        return from<number[][]>(this.contract.methods.simulateBreeding(matronTokenId, sireTokenId).call());
    }

    breedKryptomons(ownerAddress: string, matronTokenId: string, sireTokenId: string): Observable<any> {
        return from(this.contract.methods.breedKryptomons(matronTokenId, sireTokenId).send({
            ...this.contractsService.additionalParameters(), from: ownerAddress
        }))
    }

}

// export const getDataFromSimulationBreeding = (simulationData: number[]): IBreedingSimulationData => {
//     return {
//         attack: simulationData[19],
//         defense: simulationData[20],
//         constitution: simulationData[24],
//         healthPoints: simulationData[25],
//         speed: simulationData[26],
//         affections: simulationData[27],
//         crazyness: simulationData[28],
//         instinct: simulationData[29],
//         hunger: simulationData[30],
//         brave: simulationData[32],
//         smart: simulationData[33],
//         ego: simulationData[35]
//     }
// }